import LayoutLogin from '~componentes/LayoutLogin.vue';
import RecuperarSenhaAluno from './RecuperarSenhaAluno.vue';

export default {
  path: '/recuperar-senha-aluno',
  component: LayoutLogin,
  children: [
    {
      path: '',
      component: RecuperarSenhaAluno,
      name: 'recuperarsenhaaluno',
    },
  ]
}





// WEBPACK FOOTER //
// ./FrontEnd/modulos/recuperar-senha-aluno/rotas.js